<template>
	<div class="card">
		<div class="flex">
			<div class="left">
				<p class="from-to">
					TO: <strong>{{to}}</strong><br>
					FROM: <strong>{{from}}</strong>
				</p>
				<p class="message">
					<span>{{message|truncate(250)}}</span>
				</p>
			</div>
			<div class="right">
				<div ref="svg" :class="present"></div>
			</div>
		</div>
	</div>
</template>

<script>
import lottie from 'lottie-web';

export default {
	props: {
		from: {
			type: String,
			default: '',
			required: false,
		},
		to: {
			type: String,
			default: '',
			required: false,
		},
		message: {
			type: String,
			default: '',
			required: false,
		},
		present: {
			type: String,
			default: '',
			required: true,
		},
	},
	watch: {
		present: function (val) {
			if (this.lottie) {
				this.lottie.destroy();
			}
			this.lottie = lottie.loadAnimation({
				container: this.$refs['svg'],
				renderer: 'svg',
				loop: false,
				autoplay: false,
				animationData: require(`@/assets/json/${val}.json`),
				rendererSettings: {
					className: 'gift-animation',
				},
			});
		},
	},
	data () {
		return {
			lottie: null,
		};
	},
	methods: {
		async activate () {
			const sleep = ms => {
				return new Promise((resolve, reject) => setTimeout(resolve, ms));
			};
			await sleep(2000);
			if (this.lottie) {
				this.lottie.play();
			}
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';
	@import '../assets/less/components/cards.less';

	.card {
		background-image: url(../assets/images/logo.svg), url(../assets/images/logo.svg);
		background-position: left -120% bottom -120px, 255% -30%;
		background-repeat: no-repeat;
		background-size: 70%, 70%;
	}

	.left { padding: 0 1vw 0 2vw; border-right: 2px dotted @grey; text-align: left; line-height: 1.3; font-size: 14/16rem;
		.from-to {  transform: translateY(-.5rem); margin-bottom: 0; }
		.message { position: relative; margin-top: 0;
			span { display: block; .size(100%); }
			&:before { .top-left(1rem, -1.5rem); content: '“'; font-size: 2rem; line-height: 0; }
			&:after { .bottom-right(-1.5rem,-.5rem); content: '“'; font-size: 2rem; }
		}
	}

	.right { display: flex; justify-content: center; align-items: flex-end; background: transparent url(../assets/images/ico-stamp.svg) 50% 0 no-repeat; background-size: 76px;
		img, svg { width: 58px; height: auto; margin-bottom: .5rem; }
		.balloons { transform: translateY(10px) scale(.7); }
		.envelope { transform: translateY(35px) scale(1.6); }
		.giftbox { transform: translateY(10px) scale(1.5); }
		.chocolate { transform: translateY(20px); }
		.flowers { transform: translateY(15px) scale(.8); }
	}

	.gift-animation {} // Look at App.vue

</style>



// WEBPACK FOOTER //
// src/components/CardGift.vue